import './styles.scss'

import { useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { Button } from 'antd'
import { clsx } from 'clsx'

import { useDeviceDetect } from '@/hooks'

const emptyClassType = []
const emptyAllClass = {}

const FilterBar = ({
  classTypes = emptyClassType,
  onFilter,
  hasClassTypeId = '',
  allClass = emptyAllClass,
}) => {
  const { isIpadLandscape } = useDeviceDetect()
  ///
  // If property 'hasClassTypeId' equals null => initial selected value is 'All type'
  // else, selected value will be 'hasClassTypeId'
  // In Desktop view, classTypes include 'All' type, that is the first element in the array
  // In Mobile view, classTypes don't include 'All' type which is a separate property "allClass"
  ///
  const [selectedClassTypeId, setSelectedClassTypeId] = useState(
    hasClassTypeId
      || (isIpadLandscape ? allClass.categoryId : classTypes[0]?.categoryId),
  )

  const listElementRef = useRef(null)

  const [classIsScrollable, setClassIsScrollable] = useState(false)

  useLayoutEffect(() => {
    // check if classes make the wrapper scrollable
    if (listElementRef.current?.scrollWidth > listElementRef.current?.offsetWidth) {
      setClassIsScrollable(true)
    }
  }, [])

  // if there are no classes or classes don't make the wrapper scrollable, remove padding bottom
  const paddingBotValue = useMemo(
    () => (classTypes?.length === 0 || !classIsScrollable) && '0',
    [classTypes, classIsScrollable],
  )

  const filteredByClassTypeId = useCallback(
    (classTypeID) => {
      setSelectedClassTypeId(classTypeID)
      onFilter(classTypeID)
    },
    [onFilter],
  )

  const renderAllClassButton = useCallback(() => {
    const classes = clsx('filter-bar__list__item', {
      'filter-bar__list__item--selected': +selectedClassTypeId === allClass.categoryId,
    })

    return (
      isIpadLandscape && (
        <Button
          className={`${classes} filter-bar__list__item--top`}
          onClick={() => filteredByClassTypeId(allClass.categoryId)}
        >
          {allClass.categoryName} ({allClass.productCount})
        </Button>
      )
    )
  }, [allClass, filteredByClassTypeId, selectedClassTypeId, isIpadLandscape])

  const renderClassTypes = useCallback(() => {
    return classTypes.map((classType) => {
      const classes = clsx('filter-bar__list__item', {
        'filter-bar__list__item--selected': +selectedClassTypeId === classType.categoryId,
      })

      return (
        <li key={classType.categoryId}>
          <Button
            className={classes}
            onClick={() => filteredByClassTypeId(classType.categoryId)}
          >
            {classType.categoryName} ({classType.productCount})
          </Button>
        </li>
      )
    })
  }, [classTypes, filteredByClassTypeId, selectedClassTypeId])

  return (
    <div
      ref={listElementRef}
      className="filter-bar__wrapper"
      style={{ paddingBottom: paddingBotValue }}
    >
      {renderAllClassButton()}
      <ul className="filter-bar__list">{renderClassTypes()}</ul>
    </div>
  )
}

export default FilterBar
